var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9287 13.0703C10.2395 13.0703 9.67871 13.6311 9.67871 14.3203C9.67871 15.0096 10.2395 15.5703 10.9287 15.5703C11.618 15.5703 12.1787 15.0096 12.1787 14.3203C12.1787 13.6311 11.618 13.0703 10.9287 13.0703ZM10.9287 15.261C10.4206 15.261 10.0073 14.839 10.0073 14.3203C10.0073 13.8016 10.4206 13.3796 10.9287 13.3796C11.4368 13.3796 11.8501 13.8016 11.8501 14.3203C11.8501 14.839 11.4368 15.261 10.9287 15.261Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9287 16.2695C9.5502 16.2695 8.42871 17.1228 8.42871 18.1716V18.457H13.4287V18.1716C13.4287 17.1228 12.3072 16.2695 10.9287 16.2695ZM13.0737 18.1869H8.78372V18.1716C8.78372 17.2717 9.74596 16.5396 10.9287 16.5396C12.1115 16.5396 13.0737 17.2717 13.0737 18.1716V18.1869Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8037 7.4375C16.1145 7.4375 15.5537 7.99825 15.5537 8.6875C15.5537 9.37675 16.1145 9.9375 16.8037 9.9375C17.493 9.9375 18.0537 9.37675 18.0537 8.6875C18.0537 7.99825 17.493 7.4375 16.8037 7.4375ZM16.8037 9.62823C16.2956 9.62823 15.8823 9.20622 15.8823 8.68751C15.8823 8.1688 16.2956 7.74678 16.8037 7.74678C17.3118 7.74678 17.7251 8.16879 17.7251 8.6875C17.7251 9.20621 17.3118 9.62823 16.8037 9.62823Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8037 10.6367C15.4252 10.6367 14.3037 11.49 14.3037 12.5388V12.8242H19.3037V12.5388C19.3037 11.49 18.1822 10.6367 16.8037 10.6367ZM18.9487 12.5541H14.6587V12.5388C14.6587 11.6389 15.621 10.9068 16.8037 10.9068C17.9865 10.9068 18.9487 11.6389 18.9487 12.5388V12.5541Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05371 7.4375C4.36446 7.4375 3.80371 7.99825 3.80371 8.6875C3.80371 9.37675 4.36446 9.9375 5.05371 9.9375C5.74296 9.9375 6.30371 9.37675 6.30371 8.6875C6.30371 7.99825 5.74296 7.4375 5.05371 7.4375ZM5.05371 9.62823C4.54563 9.62823 4.13228 9.20622 4.13228 8.68751C4.13228 8.1688 4.54563 7.74678 5.05371 7.74678C5.56178 7.74678 5.97514 8.16879 5.97514 8.6875C5.97514 9.20621 5.56178 9.62823 5.05371 9.62823Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05371 10.6367C3.6752 10.6367 2.55371 11.49 2.55371 12.5388V12.8242H7.55371V12.5388C7.55371 11.49 6.43222 10.6367 5.05371 10.6367ZM7.19871 12.5541H2.90872V12.5388C2.90872 11.6389 3.87096 10.9068 5.05371 10.9068C6.23647 10.9068 7.19871 11.6389 7.19871 12.5388V12.5541Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9287 1.94141C10.2395 1.94141 9.67871 2.50215 9.67871 3.19141C9.67871 3.88066 10.2395 4.44141 10.9287 4.44141C11.618 4.44141 12.1787 3.88066 12.1787 3.19141C12.1787 2.50215 11.618 1.94141 10.9287 1.94141ZM10.9287 4.13213C10.4206 4.13213 10.0073 3.71013 10.0073 3.19142C10.0073 2.67271 10.4206 2.25069 10.9287 2.25069C11.4368 2.25069 11.8501 2.6727 11.8501 3.19141C11.8501 3.71012 11.4368 4.13213 10.9287 4.13213Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9287 5.14062C9.5502 5.14062 8.42871 5.99389 8.42871 7.0427V7.32812H13.4287V7.04271C13.4287 5.9939 12.3072 5.14062 10.9287 5.14062ZM13.0737 7.05803H8.78372V7.0427C8.78372 6.14283 9.74596 5.41072 10.9287 5.41072C12.1115 5.41072 13.0737 6.14283 13.0737 7.0427V7.05803Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquads);
export default __webpack_public_path__ + "static/media/squads.e8bbfebad3aa917db2b0c3b4807b94cf.svg";
export { ForwardRef as ReactComponent };